import React from 'react'
import Biote_lapis from '../../images/biote_rapid.png'

import lapis_proj from '../../images/lapis_project.png'
import Third_pane from '../Valley_Court/Blocks/Third_pane'
import BLR1 from '../../images/BLR1.jpg'
import BLR2 from '../../images/BLR2.jpg'
import BLR3 from '../../images/BLR3.jpg'
import BLR4 from '../../images/BLR4.jpg'
import BLR5 from '../../images/BLR5.jpg'
import BLR6 from '../../images/BLR6.jpg'
import BLR7 from '../../images/BLR7.jpg'
import BLR8 from '../../images/BLR8.jpg'
import BLR9 from '../../images/BLR9.jpg'
import BLR10 from '../../images/BLR10.jpg'
import BLR11 from '../../images/BLR11.jpg'
import BLR12 from '../../images/BLR12.jpg'
import BLR13 from '../../images/BLR13.jpg'
import BLR14 from '../../images/BLR14.jpg'
import BLR15 from '../../images/BLR15.jpg'
import BLR16 from '../../images/BLR16.jpg'
import BLR17 from '../../images/BLR17.jpg'
import BLR18 from '../../images/BLR18.jpg'
import BLR19 from '../../images/BLR19.jpg'
import BLR20 from '../../images/BLR20.jpg'
import BLR21 from '../../images/BLR21.jpg'
import BLR22 from '../../images/BLR22.jpg'
import BLR23 from '../../images/BLR23.jpg'
import BLR24 from '../../images/BLR24.jpg'
import BLR25 from '../../images/BLR25.jpg'
import BLR26 from '../../images/BLR26.jpg'
import BLR27 from '../../images/BLR27.jpg'
import BLR28 from '../../images/BLR28.jpg'
import BLR29 from '../../images/BLR29.jpg'
import BLR30 from '../../images/BLR30.jpg'
import BLR31 from '../../images/BLR31.jpg'


const First_pane = () => {
  return (
    <div>

<div 
         style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${Biote_lapis})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${Biote_lapis})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '85vh'
        }}

        >
            <div className='uk-container uk-margin-xlarge-top'>
                <div className='uk-grid'>
                    <div className='uk-width-1-2@s'>

                    <h1 className='light uk-text-bold header1'>Boite Lapis  Residence </h1>
                    <h5 className='light'>
                        Boîte Lapis is more than a housing project — it is a community 
                        designed to offer peace of mind, modern architecture, and long-term
                         value. Located in a strategic and accessible area, the estate 
                         combines elegant design with functional living spaces to meet 
                         today’s lifestyle needs.
                    </h5>
                    </div>

                    <div className='uk-width-1-2@s'>
  <h5 className='light'>                                       
Plot Number: Plot 1021, Cad Zone B10, Daki boiteAzure District              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,436.12M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    6 Units<br/>
Project Start Date:    March 2024 <br/>


</h5>
                    </div>
                </div>


            </div>

        
        </div>


         <div className='uk-container'>
                 <div className='uk-width-1-1 uk-margin-xlarge-top'>
                    <div className='uk-text-center'>
                     <img src={Biote_lapis} />
                     </div>
                 </div>
            </div>


          <div className='uk-container uk-margin-xlarge-top'>
              <h3 className='uk-text-center'>Real Live Realizations</h3>


                                    <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR1} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR2} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR3} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>




                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR4} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR5} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR6} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>







                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR7} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR8} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR9} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>




              
                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR10} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR11} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR12} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>









                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR13} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR14} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR15} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>








                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR16} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR17} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR18} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>











                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR19} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR20} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR21} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>







                                     
                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR22} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR23} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR24} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>











                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR25} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR26} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR27} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>












                                      <div className='row uk-margin-small-top'>
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR28} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
                                          <div className='col-sm-4'>
                                                <img 
                                                  src={BLR29} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
              
              
                                          <div className='col-sm-4'>
                                              <img 
                                                  src={BLR30} 
                                                  alt="Dynamic content" 
                                                  style={{ 
                                                      width: '100%', 
                                                      height: 'auto', 
                                                      display: 'block' 
                                                  }} 
                                              />
                                          </div>
                                     </div>










                                    
















             
          </div>
          
          <Third_pane />




        
    </div>
  )
}

export default First_pane